module.exports = __webpack_public_path__ + "fonts/TBCSailec-Black.9d832c88.eot";